// Generated by Melange

import * as Caml_option from "melange.js/caml_option.js";
import * as Lui_elements from "lui/lui_elements.js";
import * as Mapre_web__Web_message_model from "./web_message_model.js";
import * as Mapre_web__Web_subscription from "./web_subscription.js";
import * as Signal from "ocaml-signal/signal.js";
import * as Stdlib__List from "melange/list.js";
import * as Stdlib__Option from "melange/option.js";
import * as Stdlib__String from "melange/string.js";

function busy(m) {
  if (m.subscriptions_loading) {
    return true;
  } else {
    return Stdlib__Option.fold(false, (function (a) {
      return a.phase === /* Sending */ 0;
    }), m.messages.attempt);
  }
}

function compatible(m, s) {
  return Stdlib__Option.fold(false, (function (r) {
    return r.provider === s.provider;
  }), Mapre_web__Web_message_model.resume(m.messages));
}

function selected(m) {
  const s = m.messages.subscription;
  if (s !== undefined) {
    if (Stdlib__List.exists((function (current) {
        return current.id === s.id && current.authorization_version === s.authorization_version && compatible(m, current) ? Mapre_web__Web_subscription.selectable(current) : false;
      }), m.subscriptions)) {
      return "Selected: " + Mapre_web__Web_subscription.label(s);
    } else {
      return "Selected subscription changed. Select an account again.";
    }
  } else if (m.subscriptions_loading) {
    return "Loading subscriptions...";
  } else {
    return "Choose a subscription for this conversation.";
  }
}

function continuation(source, send) {
  const partial_arg = "Continuation budget (USD)";
  const partial_arg$1 = "muted";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___002_) {
      const partial_arg = Signal.own_signal(__lui_context___002_.ui_scope, Signal.map((function (m) {
        return m.subscriptions;
      }), source));
      return function (param, param$1) {
        return Lui_elements.keyed(partial_arg, (function (s) {
          return s.id;
        }), Stdlib__String.compare, (function (param) {
          const item = Signal.sample(param);
          return function (param$1, param$2) {
            return Lui_elements.scoped((function (__lui_context___001_) {
              const partial_arg = (function ($$event) {
                Lui_elements.press(send, {
                  TAG: /* Messages */ 43,
                  _0: {
                    TAG: /* Choose */ 1,
                    _0: Signal.sample(param)
                  }
                }, $$event);
              });
              const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map((function (m) {
                if (busy(m) || !compatible(m, item)) {
                  return true;
                } else {
                  return !Stdlib__List.exists((function (s) {
                    if (s.id === item.id) {
                      return Mapre_web__Web_subscription.selectable(s);
                    } else {
                      return false;
                    }
                  }), m.subscriptions);
                }
              }), source)));
              const partial_arg$2 = "outline";
              const partial_arg$3 = Caml_option.some(Signal.own_signal(__lui_context___001_.ui_scope, Signal.map(Mapre_web__Web_subscription.label, param)));
              const partial_arg$4 = {
                hd: [
                  "data-resume-subscription-id",
                  item.id
                ],
                tl: /* [] */ 0
              };
              return function (param, param$1) {
                return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, partial_arg$3, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param$1, param$2);
          };
        }), param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___003_) {
        const partial_arg = Caml_option.some(Signal.own_signal(__lui_context___003_.ui_scope, Signal.map(selected, source)));
        const partial_arg$1 = "muted";
        return function (param, param$1) {
          return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.scoped((function (__lui_context___004_) {
            const partial_arg = (function (param) {
              return Lui_elements.on_input(send, (function (text) {
                return {
                  TAG: /* Messages */ 43,
                  _0: {
                    TAG: /* Budget */ 2,
                    _0: text
                  }
                };
              }), param);
            });
            const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map(busy, source)));
            const partial_arg$2 = "Continuation budget (USD)";
            const partial_arg$3 = "Budget in USD";
            const partial_arg$4 = Caml_option.some(Signal.own_signal(__lui_context___004_.ui_scope, Signal.map((function (m) {
              return m.messages.budget;
            }), source)));
            return function (param, param$1) {
              return Lui_elements.text_field(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$4, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, /* [] */ 0, param, param$1);
            };
          }), param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$2 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$3 = 0;
  const partial_arg$4 = 8;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$4, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, param, param$1);
  };
}

function view(source, send) {
  const partial_arg = "Session settings";
  const partial_arg$1 = 2;
  const partial_arg$2 = "Messages inside an active 12-hour window keep its original deadline. After expiry, a new message starts a new window.";
  const partial_arg$3 = "muted";
  const partial_arg$4 = {
    TAG: /* Messages */ 43,
    _0: /* Refresh */ 3
  };
  const partial_arg$5 = (function (param) {
    return Lui_elements.press(send, partial_arg$4, param);
  });
  const partial_arg$6 = "ghost";
  const partial_arg$7 = "Refresh conversation";
  const partial_arg_0 = function (param, param$1) {
    return Lui_elements.scoped((function (__lui_context___006_) {
      const partial_arg = (function (param) {
        return Lui_elements.press(send, /* Refresh_subscriptions */ 0, param);
      });
      const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___006_.ui_scope, Signal.map(busy, source)));
      const partial_arg$2 = "ghost";
      const partial_arg$3 = "Refresh subscriptions";
      return function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      };
    }), param, param$1);
  };
  const partial_arg_1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___008_) {
        const partial_arg = Signal.own_signal(__lui_context___008_.ui_scope, Signal.map((function (m) {
          return m.subscription_cursor !== undefined;
        }), source));
        return function (param, param$1) {
          return Lui_elements.if_(partial_arg, (function (param, param$1) {
            return Lui_elements.scoped((function (__lui_context___009_) {
              const partial_arg = (function (param) {
                return Lui_elements.press(send, /* More_subscriptions */ 1, param);
              });
              const partial_arg$1 = Caml_option.some(Signal.own_signal(__lui_context___009_.ui_scope, Signal.map(busy, source)));
              const partial_arg$2 = "ghost";
              const partial_arg$3 = "More subscriptions";
              return function (param, param$1) {
                return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
              };
            }), param, param$1);
          }), param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.button(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$7, undefined, partial_arg$6, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$5, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: /* [] */ 0
    }
  };
  const partial_arg$8 = {
    hd: partial_arg_0,
    tl: partial_arg_1
  };
  const partial_arg$9 = "wrap";
  const partial_arg$10 = 8;
  const partial_arg_0$1 = function (param, param$1) {
    return Lui_elements.heading(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$1, partial_arg, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
  };
  const partial_arg_1$1 = {
    hd: (function (param, param$1) {
      return Lui_elements.scoped((function (__lui_context___005_) {
        const partial_arg = continuation(source, send);
        const partial_arg$1 = Signal.own_signal(__lui_context___005_.ui_scope, Signal.map((function (m) {
          return Mapre_web__Web_message_model.resume(m.messages) !== undefined;
        }), source));
        return function (param, param$1) {
          return Lui_elements.if_(partial_arg$1, partial_arg, param, param$1);
        };
      }), param, param$1);
    }),
    tl: {
      hd: (function (param, param$1) {
        return Lui_elements.text(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$3, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$2, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* [] */ 0, param, param$1);
      }),
      tl: {
        hd: (function (param, param$1) {
          return Lui_elements.row(undefined, partial_arg$10, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$9, undefined, partial_arg$8, param, param$1);
        }),
        tl: /* [] */ 0
      }
    }
  };
  const partial_arg$11 = {
    hd: partial_arg_0$1,
    tl: partial_arg_1$1
  };
  const partial_arg$12 = 0;
  const partial_arg$13 = 12;
  return function (param, param$1) {
    return Lui_elements.column(undefined, partial_arg$13, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$12, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, partial_arg$11, param, param$1);
  };
}

export {
  view,
}
/* Lui_elements Not a pure module */
